const Button = {
  baseStyle: {
    borderRadius: 'button',
    fontWeight: 600,
    maxW: '100%',
    pos: 'relative',
    px: '24px',

    // This may look ugly, but it's the only way I can think of to position the icons within the button
    '& > span:first-of-type.chakra-button__icon': {
      marginRight: 'auto',
    },
    '& > span:last-of-type.chakra-button__icon': {
      marginLeft: 'auto',
      marginRight: '0',
    },
  },
  variants: {
    primary: {
      bg: 'pink.500',
      color: 'white',
      fontWeight: 600,
      borderRadius: '35px',
      height: '50px',
    },
    dashed: {
      bg: 'primary.50',
      borderRadius: 'base',
      border: '1px dashed',
      borderColor: 'secondary.300',
      color: 'secondary.700',
      height: '50px',
    },
    ghost: {
      bg: 'none',
      border: 'none',
      color: 'secondary.500',
      _hover: {
        color: 'primary.500',
        bg: 'none',
      },
    },
    outline: {
      bg: 'none',
      color: 'secondary.700',
      border: '1px solid',
      borderColor: 'secondary.700',
      h: '50px',
      _hover: {
        bg: 'none',
      },
      _active: { bg: 'none' },
    },
  },
  defaultProps: {
    variant: 'primary',
  },
};

export default Button;
